(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const routes = (window.BNB && window.BNB.routes) || {};

  /* ---------- Menú móvil ---------- */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]');
    const openButton = $('[data-mobile-menu-open]');
    if (!menu || !openButton) return;
    const panel = $('.mobile-menu__panel', menu);
    const closeButtons = $$('[data-mobile-menu-close]', menu);

    const focusables = () => $$('a[href], button:not([disabled]), input, select, textarea, summary', panel)
      .filter((el) => el.offsetParent !== null);

    const setOpen = (open) => {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
      if (open) {
        $('.mobile-menu__close', menu)?.focus();
      } else {
        openButton.focus();
      }
    };

    openButton.addEventListener('click', () => setOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Escape') setOpen(false);
      if (event.key === 'Tab') {
        const items = focusables();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Filtros en móvil ---------- */
  function initFilterDrawer() {
    const toggle = $('[data-filter-toggle]');
    const panel = $('[data-filter-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', () => {
      const open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Cantidad (respeta mínimos y múltiplos) ---------- */
  function initQuantityControls(root = document) {
    $$('[data-quantity]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = 'true';
      const input = $('input[type="number"]', wrap);
      if (!input) return;
      const min = () => Number(input.min || 1);
      const step = () => Number(input.step || 1);
      const max = () => (input.max ? Number(input.max) : Infinity);
      $('[data-qty-minus]', wrap)?.addEventListener('click', () => {
        input.value = Math.max(min(), Number(input.value || min()) - step());
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      $('[data-qty-plus]', wrap)?.addEventListener('click', () => {
        input.value = Math.min(max(), Number(input.value || min()) + step());
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Envío automático de filtros / ordenación / carrito ---------- */
  function initAutoSubmit() {
    document.addEventListener('change', (event) => {
      const control = event.target.closest('[data-auto-submit]');
      if (control && control.form) control.form.submit();
    });
  }

  /* ---------- Galería de producto ---------- */
  function initProductGallery() {
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;
      event.preventDefault();
      const gallery = thumb.closest('.product-gallery');
      const main = $('[data-product-main-image]', gallery);
      if (!main) return;
      main.src = thumb.dataset.productThumb;
      if (thumb.dataset.productSrcset) main.srcset = thumb.dataset.productSrcset;
      main.alt = thumb.dataset.productAlt || '';
      $$('.product-gallery__thumb', gallery).forEach((t) => t.classList.toggle('is-active', t === thumb));
    });
  }


  /* ---------- Variantes: carga completa (productos con más de 250 combinaciones) ---------- */
  const PAGE_SIZE = 250;
  function loadAllVariants(section, initial) {
    const total = Number(section.dataset.variantsCount || 0);
    const productUrl = section.dataset.productUrl;
    if (!total || total <= initial.length || !productUrl) return Promise.resolve(initial);
    const pages = Math.ceil(total / PAGE_SIZE);
    const requests = [];
    for (let page = 2; page <= pages; page += 1) {
      requests.push(
        fetch(`${productUrl}?section_id=bnb-variant-data&page=${page}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const el = $('[data-variants-page]', doc);
            return el ? JSON.parse(el.textContent) : [];
          })
          .catch(() => [])
      );
    }
    return Promise.all(requests).then((chunks) => {
      const seen = new Set(initial.map((v) => v.id));
      const merged = initial.slice();
      chunks.flat().forEach((v) => { if (!seen.has(v.id)) { seen.add(v.id); merged.push(v); } });
      if (merged.length >= total) return merged;
      // Alternativa: endpoint .js del producto
      return fetch(`${productUrl}.js`).then((r) => r.json()).then((data) => {
        (data.variants || []).forEach((v) => {
          if (!seen.has(v.id)) {
            seen.add(v.id);
            merged.push({ id: v.id, options: v.options, available: v.available, price: v.price, featured_media: !!v.featured_media });
          }
        });
        return merged;
      }).catch(() => merged);
    });
  }

  function formatMoney(cents, format) {
    const fmt = format || '{{amount_with_comma_separator}} €';
    const value = (Number(cents) / 100);
    const withSep = (decimals, thousands, decimal) => {
      const fixed = value.toFixed(decimals);
      const [int, dec] = fixed.split('.');
      const intSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? `${intSep}${decimal}${dec}` : intSep;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withSep(0, ',', '.');
        case 'amount_with_comma_separator': return withSep(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(2, "'", '.');
        default: return withSep(2, ',', '.');
      }
    });
  }

  /* ---------- Cuadrícula de pedido (Forma × Color) ---------- */
  function initVariantGrids() {
    $$('[data-product-section]').forEach((section) => {
      const grid = $('[data-variant-grid]', section);
      if (!grid) return;
      const variantsEl = $('[data-variants]', grid);
      let variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const inputs = $$('.variant-grid__qty', grid);
      const summary = $('[data-grid-summary]', grid);
      const addButton = $('[data-grid-add]', grid);
      const clearButton = $('[data-grid-clear]', grid);
      const errorEl = $('[data-grid-error]', grid);
      const moneyFormat = grid.dataset.moneyFormat;
      const key = (a, b) => `${a}\u0001${b}`;
      let map = new Map();

      const buildMap = () => {
        map = new Map(variants.map((v) => [key(v.options[0], v.options[1]), v]));
        inputs.forEach((input) => {
          const v = map.get(key(input.dataset.o1, input.dataset.o2));
          const cell = input.closest('td');
          const missing = !v || !v.available;
          input.disabled = missing;
          if (missing) { input.value = ''; input.placeholder = '—'; }
          cell.classList.toggle('is-unavailable', missing);
          if (v) input.dataset.variantId = v.id;
        });
        update();
      };

      const selected = () => inputs
        .map((input) => ({ input, qty: Math.max(0, parseInt(input.value, 10) || 0) }))
        .filter((x) => x.qty > 0);

      function update() {
        const items = selected();
        let units = 0; let total = 0; let missing = 0;
        items.forEach(({ input, qty }) => {
          const v = map.get(key(input.dataset.o1, input.dataset.o2));
          units += qty;
          if (v) total += v.price * qty; else missing += 1;
        });
        inputs.forEach((input) => input.closest('td').classList.toggle('has-qty', (parseInt(input.value, 10) || 0) > 0));
        if (units === 0) {
          summary.textContent = 'Aún no has elegido ninguna unidad';
        } else {
          const combos = items.length === 1 ? '1 combinación' : `${items.length} combinaciones`;
          summary.innerHTML = `<strong>${units} ${units === 1 ? 'unidad' : 'unidades'}</strong> · ${combos} · <strong>${formatMoney(total, moneyFormat)}</strong> <span class="variant-grid__tax">+ IVA</span>`;
        }
        addButton.disabled = units === 0 || missing > 0;
        clearButton.hidden = units === 0;
      }

      grid.addEventListener('input', (event) => {
        if (event.target.matches('.variant-grid__qty')) {
          if (event.target.value.includes('-')) event.target.value = '';
          errorEl.hidden = true;
          update();
        }
      });
      grid.addEventListener('focusin', (event) => {
        if (event.target.matches('.variant-grid__qty')) event.target.select();
      });

      clearButton.addEventListener('click', () => {
        inputs.forEach((input) => { input.value = ''; });
        update();
      });

      addButton.addEventListener('click', () => {
        const items = selected().map(({ input, qty }) => ({ id: Number(input.dataset.variantId), quantity: qty })).filter((x) => x.id);
        if (!items.length) return;
        addButton.disabled = true;
        addButton.classList.add('is-loading');
        fetch(grid.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) throw new Error(data.description || data.message || 'No se ha podido añadir al carrito.');
            window.location.href = grid.dataset.cartUrl;
          })
          .catch((error) => {
            errorEl.textContent = error.message;
            errorEl.hidden = false;
            addButton.disabled = false;
            addButton.classList.remove('is-loading');
          });
      });

      buildMap();
      if (Number(section.dataset.variantsCount || 0) > variants.length) {
        addButton.disabled = true;
        summary.textContent = 'Cargando combinaciones…';
        loadAllVariants(section, variants).then((all) => { variants = all; buildMap(); });
      }
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariantPickers() {
    $$('[data-product-section]').forEach((section) => {
      const picker = $('[data-variant-picker]', section);
      if (!picker) return;
      const variantsEl = $('[data-variants]', picker);
      if (!variantsEl) return;
      let variants = JSON.parse(variantsEl.textContent);
      loadAllVariants(section, variants).then((all) => { variants = all; });
      const sectionId = section.dataset.sectionId;
      const productUrl = section.dataset.productUrl;
      let controller;

      const selectedOptions = () => {
        const values = [];
        $$('[data-option-index]', picker).forEach((el) => {
          const index = Number(el.dataset.optionIndex);
          if (el.tagName === 'SELECT') values[index] = el.value;
          else if (el.checked) values[index] = el.value;
        });
        return values;
      };

      const setUnavailable = () => {
        const button = $('[name="add"]', section);
        if (button) { button.disabled = true; button.textContent = 'No disponible'; }
      };

      picker.addEventListener('change', (event) => {
        const el = event.target.closest('[data-option-index]');
        if (!el) return;
        const fieldset = el.closest('fieldset');
        const label = fieldset && $('[data-option-selected]', fieldset);
        if (label) label.textContent = el.value;

        const options = selectedOptions();
        const variant = variants.find((v) => v.options.every((value, i) => value === options[i]));
        if (!variant) { setUnavailable(); return; }

        $$('[data-variant-id]', section).forEach((input) => { input.value = variant.id; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (controller) controller.abort();
        controller = new AbortController();
        fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`, { signal: controller.signal })
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            ['price', 'meta', 'buy'].forEach((key) => {
              const current = $(`[data-update="${key}"]`, section);
              const fresh = $(`[data-update="${key}"]`, doc);
              if (current && fresh) current.innerHTML = fresh.innerHTML;
            });
            if (variant.featured_media) {
              const freshGallery = $('[data-update="gallery"]', doc);
              const gallery = $('[data-update="gallery"]', section);
              if (freshGallery && gallery) gallery.innerHTML = freshGallery.innerHTML;
            }
            $$('[data-quantity]', section).forEach((w) => delete w.dataset.ready);
            initQuantityControls(section);
          })
          .catch((error) => { if (error.name !== 'AbortError') console.error(error); });
      });
    });
  }

  /* ---------- Búsqueda predictiva ---------- */
  function initPredictiveSearch() {
    $$('[data-predictive-search]').forEach((form) => {
      const input = $('input[type="search"]', form);
      const results = $('[data-predictive-results]', form);
      if (!input || !results || !routes.predictiveSearch) return;
      let timer;
      let controller;

      const close = () => {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      input.addEventListener('input', () => {
        clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 2) { close(); return; }
        timer = setTimeout(() => {
          if (controller) controller.abort();
          controller = new AbortController();
          const params = new URLSearchParams({
            q: term,
            section_id: 'predictive-search',
            'resources[type]': 'product,collection,query',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor,tag'
          });
          fetch(`${routes.predictiveSearch}?${params.toString()}`, { signal: controller.signal })
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const content = $('[data-predictive-search-results]', doc);
              results.innerHTML = content ? content.outerHTML : '';
              results.hidden = !content;
              input.setAttribute('aria-expanded', content ? 'true' : 'false');
            })
            .catch((error) => { if (error.name !== 'AbortError') close(); });
        }, 220);
      });

      input.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
      document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
      input.addEventListener('focus', () => { if (results.innerHTML.trim() && input.value.trim().length >= 2) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    });
  }

  /* ---------- Productos relacionados ---------- */
  function initRecommendations() {
    $$('[data-product-recommendations]').forEach((section) => {
      const url = section.dataset.url;
      if (!url) return;
      const load = () => {
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = $('[data-product-recommendations]', doc);
            if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        observer.observe(section);
      } else {
        load();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initFilterDrawer();
    initQuantityControls();
    initAutoSubmit();
    initProductGallery();
    initVariantPickers();
    initVariantGrids();
    initPredictiveSearch();
    initRecommendations();
  });
})();
